import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { FormText } from 'types/cms';

import TextField from '@material-ui/core/TextField';

type InputType = Omit<FormText, '__component' | 'id'> & {
  type: 'text' | 'email';
};

const TextInput = ({
  control,
  identifier,
  label,
  max_length,
  required,
  type = 'text',
}: InputType & { control: Control }) => {
  return (
    <Controller
      name={identifier}
      control={control}
      defaultValue=""
      render={props => (
        <TextField
          {...props}
          label={label}
          type={type}
          required={required}
          inputProps={{ maxLength: max_length, 'data-testid': identifier }}
          autoComplete={type === 'text' ? 'name' : 'email'}
        />
      )}
    />
  );
};

export default TextInput;
